export default __webpack_public_path__ + "static/media/nestjs.8cc42ce9.svg";